import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  previousYearQuestionData: [],
  totalpreviousYearQuestion: 0,
  isOpenModal: false,
  isStatusOpenModal: false,
}

export const previousYearQuestionSlice = createSlice({
  name: "previousYearQuestion",
  initialState,
  reducers: {
    setpreviousYearQuestionData(state, { payload }) {
      state.previousYearQuestionData = payload.result
      state.totalpreviousYearQuestion = payload.total
    },
    updatepreviousYearQuestionData(state, { payload }) {
      const objIndex = state.previousYearQuestionData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.previousYearQuestionData[objIndex] = payload
      }
    },
    deletepreviousYearQuestionData(state, { payload }) {
      const objIndex = state.previousYearQuestionData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.previousYearQuestionData.splice(objIndex, 1)
        state.totalpreviousYearQuestion -= 1
      }
    },
    pushpreviousYearQuestionData(state, { payload }) {
      state.previousYearQuestionData.push(payload)
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
    isOpenStatusModal(state, { payload }) {
      state.isStatusOpenModal = payload
    },
    statusToggle(state, { payload }) {
      state.isStatusOpenModal = !state.isStatusOpenModal
    }
  }
})

export const { setpreviousYearQuestionData, updatepreviousYearQuestionData, deletepreviousYearQuestionData, pushpreviousYearQuestionData, isOpenModal,
  ModalToggle, setFaqsSpecializationData, isOpenStatusModal, statusToggle } = previousYearQuestionSlice.actions;

export default previousYearQuestionSlice.reducer;

export function getpreviousYearQuestion(limit, offset, status, keyword, id) {
  return async function getpreviousYearQuestionThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getpreviousYearQuestion(limit, offset, status, keyword, id).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setpreviousYearQuestionData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addpreviousYearQuestion(payload) {
  return async function addpreviousYearQuestionThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addPreviousYearQuestion(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushpreviousYearQuestionData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updatepreviousYearQuestion(id, data) {
  return async function updatepreviousYearQuestionThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updatePreviousYearQuestion(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updatepreviousYearQuestionData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function statusUpdatepreviousYearQuestion(payload) {
  return async function statusUpdatepreviousYearQuestionThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.statusUpdatepreviousYearQuestion(payload.id, payload.status).then(
        (response) => {
          dispatch(statusToggle())
          dispatch(updatepreviousYearQuestionData(response.data))
          dispatch(setLoading(false))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function statusDeletepreviousYearQuestion(id) {
  return async function statuseletepreviousYearQuestionThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.statusUpdatepreviousYearQuestion(id, "deleted").then(
        (response) => {          
          dispatch(deletepreviousYearQuestionData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

